import { Clickable, H3 } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import classNames from 'classnames';

import styles from './styles.module.sass';

type NavProps = {
  alignment?: 'horizontal' | 'vertical';
  ariaLabel?: string;
  className?: string;
  items: {
    isActive?: boolean;
    inNewTab?: boolean;
    name: string;
    onClick?: (...args: unknown[]) => unknown;
    url: string;
  }[];
  title?: string;
  variant?: 'dark' | 'regular';
};

const Nav = ({ alignment = 'vertical', ariaLabel, className, items, title, variant = 'regular' }: NavProps) => (
  <div className={classNames(styles[alignment], styles[variant], className)}>
    {title && (
      <H3 looksLike="h4" className={styles.title} variant={['marginBottomSpacerNone', 'marginTopSpacerNone']}>
        {title}
      </H3>
    )}
    <nav aria-label={ariaLabel}>
      <ul className={styles.items}>
        {map(
          ({ inNewTab, isActive, onClick, name, url }) => (
            // @ts-expect-error - Automatic, Please fix when editing this file
            <li key={url} className={classNames(styles.item, { [styles.active]: isActive })}>
              <Clickable
                to={url}
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '(string | undefined)[]' is not assignable to type 'string'.
                className={[title ? styles.handyLink : styles.link]}
                analytics={{ label: name }}
                onClick={onClick}
                inNewTab={inNewTab}
              >
                {name}
              </Clickable>
            </li>
          ),
          items,
        )}
      </ul>
    </nav>
  </div>
);

export default Nav;
